import { z } from 'zod';
import { AVAILABLE_OVERVIEW_VIEWS } from './constants';

export const overviewViewSearchParam = z.enum(AVAILABLE_OVERVIEW_VIEWS).optional().catch('list');
